import { useState } from "react";

interface SwitchProps {
    selectedIndex: number;
    choices: string[];
    onSelect: (index: number) => void;
}


// Switch wrapper, render a SwitchButton per choices
export default function Switch(props: SwitchProps) {
    /**
     * Quick and dirty solution for selectiing the right tab depending on the url.
     */
    /*
    var locationIndex = 0;
    const currentUrl = window.location.href;
    if (currentUrl.includes("genevhack.ch")) {
        locationIndex = 0;
    } else if (currentUrl.includes("limmathack.ch")) {
        locationIndex = 1;
    } 
    */
    const { selectedIndex, choices, onSelect } = props;
    const [selected, setSelected] = useState(selectedIndex);
    return (
        <div className="switch-wrapper">
            {choices.map((choice, index) => (
                <SwitchButton
                    key={index}
                    selected={selected === index}
                    text={choice}
                    onClick={() => {
                        setSelected(index);
                        if (onSelect) {
                            onSelect(index);
                        }
                    }}
                />
            ))}
        </div>
    );
}

interface SwitchButtonProps {
    text: string;
    selected: boolean;
    onClick?: () => void;
}

// Represent a single button in the switch, state is managed by the parent
export function SwitchButton(props: SwitchButtonProps) {
    const { selected, onClick } = props;
    return (
        <button className={`btn switch ${selected ? 'btn-orange' : 'off'} `}
            onClick={onClick}
        >
            {props.text}
        </button>
    );
}